import { defineNuxtPlugin } from 'nuxt/app';
import type { NuxtApp } from 'nuxt/app';
// Removed vue-slide-up-down plugin: not compatible with Vue 3
export default defineNuxtPlugin((nuxtApp: NuxtApp) => {
  // Plugin code removed
});
